var map = {
	"./home.jpg": 545,
	"./slider-1.jpg": 546,
	"./slider-2.jpg": 547,
	"./slider-3.jpg": 548,
	"./slider.scss": 371,
	"./slider.view": 256,
	"./slider.view.jsx": 256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 544;